import {
  alpha,
  createTheme,
  darken,
  getContrastRatio,
  lighten,
} from '@mui/material/styles';
import createBaseTheme from 'theme/makeTheme';

const getValidColor = (color, defaultColor) => {
  if (!color) return defaultColor;
  if (color[0] === '#') return color;
  if (color.length === 6) return `#${color}`;
  if (color.length === 3) return `#${color}`;
  return defaultColor;
};

export default ({ primary, text }) => {
  const primaryColor = getValidColor(primary, '#038AFF');
  const textColor = getValidColor(text, primaryColor);
  const baseTheme = createBaseTheme('TIC', 'light');

  // return baseTheme;

  const theme = createTheme(baseTheme, {
    typography: {
      fontFamily: 'Poppins, sans-serif',
    },
    palette: {
      text: {
        primary: textColor,
      },
      primary: baseTheme.palette.augmentColor({
        color: {
          main: primaryColor,
        },
        name: 'custom',
      }),
      background: {
        default: lighten(primaryColor, 0.85),
        paper1: alpha(primaryColor, 0.1),
      },
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            backgroundColor: lighten(primaryColor, 0.85),
          },
          '*': {
            scrollbarWidth: 'none',
            '--webkit-scrollbar': 'none',
          },
        },
      },
      MuiDialog: {
        defaultProps: {
          disablePortal: true,
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            fontWeight: 500,
            borderRadius: 30,
            fontSize: '1rem',
          },
          sizeLarge: {
            fontSize: '1.2rem',
          },
        },
      },
      MuiIconButton: {
        styleOverrides: {
          root: {
            backgroundColor: alpha(primaryColor, 0.1),
            color: lighten(primaryColor, 0.1),
            '&:hover': {
              backgroundColor: alpha(primaryColor, 0.2),
              color: primaryColor,
            },
          },
        },
      },
    },
  });
  console.log(theme);
  return theme;
};
